/**
 * Copyright (c) Nicolas Gallagher
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

module.exports = require('./dist/transform-localize-style');



// WEBPACK FOOTER //
// ./node_modules/styleq/transform-localize-style.js